import React from 'react'
import { useTranslation } from 'react-i18next'

import PickingMovementsList from '@shared/picking_movements/PickingMovementsList'
import ListPageHeader from '@shared/ListPageHeader'

import { pickingMovementsService } from '@services/operator/pickingMovementsService'

export default function OperatorPickingMovementsList() {
  const { t } = useTranslation()
  return (
    <div>
      <ListPageHeader
        items={[
          { label: t('operator.menu.picking.title') },
          { label: t('operator.menu.picking_lists.history') },
        ]}
      />
      <PickingMovementsList
        service={pickingMovementsService}
        role="operator"
      />
    </div>
  )
}
